import clsx from 'clsx'
import { HugeiconsIcon } from '@hugeicons/react'
import { Tick01Icon } from '@hugeicons/core-solid-rounded'
import { GraphQL } from '@guestgoodie/graphql'

import * as Table from '@/components/ui/Table'

interface RowProps {
  guest: GraphQL.GuestFragmentFragment
  isSelected: boolean
  onSelect: () => void
}

export default function GuestRow({ guest, isSelected, onSelect }: RowProps) {
  return (
    <Table.Row
      className={clsx('cursor-pointer', isSelected && 'is-active')}
      onClick={onSelect}
      onEnter={onSelect}
    >
      <Table.Cell>
        {isSelected && (
          <HugeiconsIcon icon={Tick01Icon} className="size-5 text-text" />
        )}
      </Table.Cell>
      <Table.Cell>{guest.title}</Table.Cell>
      <Table.Cell>
        {guest.firstName} {guest.lastName}
      </Table.Cell>
      <Table.Cell>{guest.email}</Table.Cell>
    </Table.Row>
  )
}
